import classNames from "classnames";
import { FC } from "react";
import styled from "styled-components";

import { CheckIcon } from "../SvgIcon";

interface IProps {
  steps: { label: string; id: number }[];
  currentStep: number;
  completedSteps: number[];
  classes?: string;
  onChangeStep: (val: number) => void;
  orientation?: "horizontal" | "vertical";
  activeColor?: string;
}

const Container = styled.div`
  *:before,
  *:after {
    box-sizing: border-box;
  }
`;

export const FormStepper: FC<IProps> = ({
  steps,
  currentStep,
  completedSteps,
  classes = "",
  onChangeStep,
  orientation = "vertical",
  activeColor = "primary"
}) => {
  if (orientation === "horizontal")
    return (
      <div className={`overflow-auto ${classes}`}>
        <div className="flex">
          {steps.map((step, idx) => (
            <div
              key={step.id}
              className={classNames("w-full flex flex-col items-center", {
                "step-active": currentStep === step.id,
                "cursor-not-allowed": !completedSteps.includes(step.id) && currentStep !== step.id
              })}
              onClick={() => {
                if (completedSteps.includes(step.id)) {
                  onChangeStep(step.id);
                }
              }}
              role="button"
            >
              <div className="w-full flex flex-col items-center">
                <div>
                  <div
                    className={classNames(
                      "flex items-center justify-center w-10 h-10 rounded-full relative font-bold",
                      {
                        "bg-gray text-gray-dark": currentStep !== step.id,
                        [`bg-${activeColor} text-white`]: currentStep === step.id
                      }
                    )}
                  >
                    {step.id < currentStep ? (
                      <CheckIcon strokeColor="bg-white text-primary-dark w-10 h-10 rounded-full" />
                    ) : (
                      step.id
                    )}
                  </div>
                </div>
                {idx === steps.length - 1 ? null : (
                  <div
                    className={classNames("w-full h-1 bg-gray-300 ml-[100%] -mt-5", {
                      "bg-primary-dark": step.id < currentStep
                    })}
                  />
                )}
              </div>
              <div
                className={classNames("py-10", {
                  "-mt-4": idx === steps.length - 1
                })}
              >
                <p
                  className={classNames("text-center text-sm", {
                    "text-primary-dark": currentStep === step.id,
                    "text-gray-dark": currentStep !== step.id
                  })}
                >
                  {step.label}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  return (
    <Container className={`col-span-2 w-full lg:w-fit h-full flex flex-row justify-between lg:flex-col ${classes}`}>
      <div>
        {steps.map((step, idx) => (
          <div
            key={step.id}
            className={classNames("flex", {
              "step-active": currentStep === step.id,
              "cursor-not-allowed": !completedSteps.includes(step.id) && currentStep !== step.id
            })}
            onClick={() => {
              if (completedSteps.includes(step.id)) {
                onChangeStep(step.id);
              }
            }}
            role="button"
          >
            <div className="flex flex-col items-center mr-4">
              <div>
                <div
                  className={classNames("flex items-center justify-center w-4 h-4 rounded-full", {
                    "bg-gray-400": currentStep !== step.id,
                    [`bg-${activeColor}`]: currentStep === step.id
                  })}
                >
                  {step.id < currentStep ? <CheckIcon strokeColor="bg-white text-green-600 w-4 h-4" /> : null}
                </div>
              </div>
              {idx === steps.length - 1 ? null : (
                <div
                  className={classNames("w-px h-full bg-gray-300", {
                    "bg-green-500": step.id < currentStep
                  })}
                />
              )}
            </div>
            <div className="pb-10">
              <p
                className={classNames("text-sm", {
                  "text-primary": currentStep === step.id,
                  "text-dark-grey": currentStep !== step.id
                })}
              >
                {step.label}
              </p>
            </div>
          </div>
        ))}
      </div>
    </Container>
  );
};
